import useCatalogDeleteOptions from "@components/Actions/useCatalogDeleteOptions";
import Icon from "@components/Atoms/Icon";
import { catalogDeleteConfirm } from "@ext/catalog/actions/propsEditor/components/catalogDeleteConfirm";
import {
	useDeleteCatalog,
	useDeleteCatalogFromSpace,
} from "@ext/catalog/actions/propsEditor/components/useDeleteCatalog";
import t from "@ext/localization/locale/translate";
import type { CatalogLink } from "@ext/navigation/NavigationLinks";
import { ConfirmMenuItem } from "@ui-kit/ConfirmPopover";

const CardDeleteActions = ({ catalogLink }: { catalogLink: CatalogLink }) => {
	const { name } = catalogLink;
	const unpublished = catalogLink.status === "unpublished";
	const { plain, fromDevice, fromSpace } = useCatalogDeleteOptions(name, !unpublished);
	const deleteCatalog = useDeleteCatalog({ name });
	const deleteFromSpace = useDeleteCatalogFromSpace({ name });

	return (
		<>
			{plain && (
				<ConfirmMenuItem
					confirm={catalogDeleteConfirm(unpublished ? "local" : "storage")}
					onClick={(e) => e.stopPropagation()}
					onConfirm={deleteCatalog}
					type="danger"
				>
					<Icon code="trash" />
					{t("catalog.delete.name")}
				</ConfirmMenuItem>
			)}
			{fromDevice && (
				<ConfirmMenuItem
					confirm={catalogDeleteConfirm("device")}
					onClick={(e) => e.stopPropagation()}
					onConfirm={deleteCatalog}
				>
					<Icon code="monitor-x" />
					{t("catalog.delete.device.name")}
				</ConfirmMenuItem>
			)}
			{fromSpace && (
				<ConfirmMenuItem
					confirm={catalogDeleteConfirm("space")}
					onClick={(e) => e.stopPropagation()}
					onConfirm={deleteFromSpace}
					type="danger"
				>
					<Icon code="trash" />
					{t("catalog.delete.space.name")}
				</ConfirmMenuItem>
			)}
		</>
	);
};

export default CardDeleteActions;
